import React, { useMemo, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Button, Col, Form, Label, Row } from "reactstrap"
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import moment from "moment"
import { providerDashboardAction } from "store/provider-dashboard/provider-dashboard-slice"
import { isObject } from "lodash"
import { getFacilities, getItems } from "store/admin/admin-dashboard-action"

const ProviderDistributionActionRequestFilter = ({
  onAdvancedSearchSubmit,
  loading,
}) => {
  const distributionFlatpickerfrom = useRef(null)
  const distributionFlatpickerto = useRef(null)
  const [category, setCategory] = useState(null)
  const [province, setProvince] = useState(null)
  const [facility, setFacility] = useState(null)
  const [item, setItem] = useState(null)
  const [ip, setIP] = useState(null)
  const [project, setProject] = useState(null)
  const [expireDate, setExpireDate] = useState({
    from: null,
    to: null,
  })
  const [distributionDate, setDistributionDate] = useState({
    from: null,
    to: null,
  })

  // fetch items
  const items = useSelector(state => state.adminDashboard.Items)
  // fetch items categories
  const categories = useSelector(state => state.adminDashboard.ItemCategoires)

  // fetch provinces
  const provinces = useSelector(state => state.adminDashboard.Provinces)

  // fetch projects
  const projects = useSelector(state => state.adminDashboard.Projects)

  // fetch IPs
  const ips = useSelector(state => state.adminDashboard.Ips)

  // fetch facilities
  const facilities = useSelector(state => state.adminDashboard.Facilities)

  // filtered items based select compoent
  const filteredItems = useMemo(
    () =>
      items?.data.map(item => ({
        value: item.id,
        label: `${item.unfp_item_name} ( ${item.item_name} )`,
      })),
    [items]
  )

  const dispatch = useDispatch()

  // handleSubmit: Triggered when the form is submitted
  const handleSubmit = () => {
    let data = {}
    data.item = isObject(item) ? item.value : null
    data.project = isObject(project) ? project.value : null
    data.category = isObject(category) ? category.value : null
    data.ip = isObject(ip) ? ip.value : null
    data.province = isObject(province) ? province.value : null
    data.facility = isObject(facility) ? facility.value : null
    data.distributionDate = {
      from: distributionDate.from ? distributionDate.from : null,
      to: distributionDate.to ? distributionDate.to : null,
    }
    onAdvancedSearchSubmit(data)
  }

  // store Item Categories and fetch items based item category
  const onCategoryChangeHandler = cate => {
    setCategory(cate)
    dispatch(getItems(cate.value))
  }

  // store item
  const onItemChangeHandler = item => {
    setItem(item)
  }

  // store province and fetch facilities based province id
  const onProvinceChangeHandler = value => {
    setProvince(value)
    dispatch(getFacilities(value.value))
  }

  // store facility value
  const onFacilityChangeHandler = value => {
    setFacility(value)
  }
  // store IP
  const onIPChangeHandler = value => {
    setIP(value)
  }

  // store project
  const onProjectChangeHandler = value => {
    setProject(value)
  }

  // clear search when clear button clicked
  const onClearHandler = () => {
    distributionFlatpickerfrom.current.flatpickr.clear()
    distributionFlatpickerto.current.flatpickr.clear()
    setCategory(null)
    setItem(null)
    setProvince(null)
    setFacility(null)
    setIP(null)
    setDistributionDate({ from: null, to: null })
    setProject(null)
    onAdvancedSearchSubmit({})
    dispatch(providerDashboardAction.resetProviderItems())
    dispatch(providerDashboardAction.resetProviderFacilities())
  }

  return (
    <Form
      onSubmit={e => {
        e.preventDefault()
        handleSubmit()
        return false
      }}
    >
      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">IPs</Label>
            {ips?.data && (
              <Select
                options={ips?.data}
                value={ip}
                onChange={onIPChangeHandler}
              />
            )}
          </Col>
          <Col>
            <Label className="form-label">Projects</Label>
            {projects?.data && (
              <Select
                options={projects?.data}
                value={project}
                onChange={onProjectChangeHandler}
              />
            )}
          </Col>
        </Row>
      </div>

      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Province</Label>
            {provinces?.data && (
              <Select
                options={provinces?.data}
                value={province}
                onChange={onProvinceChangeHandler}
              />
            )}
          </Col>
          <Col>
            <Label className="form-label">Facilities</Label>
            {facilities?.data && (
              <Select
                options={facilities?.data}
                value={facility}
                onChange={onFacilityChangeHandler}
              />
            )}
          </Col>
        </Row>
      </div>

      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Item Categories</Label>
            {categories?.data && (
              <Select
                options={categories?.data}
                value={category || categories?.data[0]}
                onChange={onCategoryChangeHandler}
              />
            )}
          </Col>
          <Col>
            <Label className="form-label">Items</Label>
            {filteredItems && (
              <Select
                options={[{ value: "all", label: "All" }, ...filteredItems]}
                value={item}
                onChange={onItemChangeHandler}
              />
            )}
          </Col>
        </Row>
      </div>

      <div className="mb-3 ">
        <Label className="form-label">Distribution Date</Label>
        <Row>
          <Col>
            <Flatpickr
              ref={distributionFlatpickerfrom}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setDistributionDate(prev => {
                  return {
                    ...prev,
                    from: moment(value[0]).format("YYYY-MM-DD"),
                  }
                })
              }}
            />
          </Col>
          <Col>
            <Flatpickr
              ref={distributionFlatpickerto}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setDistributionDate(prev => {
                  return { ...prev, to: moment(value[0]).format("YYYY-MM-DD") }
                })
              }}
            />
          </Col>
        </Row>
      </div>

      <div className="d-flex flex-wrap gap-2 mb-4">
        <Button
          type="submit"
          className="btn btn-sm btn-primary"
          color="primary"
          disabled={loading}
        >
          {loading ? "Please Wait..." : "Search"}
        </Button>
        <Button
          onClick={onClearHandler}
          className="btn btn-sm btn-danger"
          color="primary"
        >
          Clear
        </Button>
      </div>
    </Form>
  )
}

export default ProviderDistributionActionRequestFilter
